import {
    AJAX_TYPE
} from '../config';

// Dev.ToolManager

const prefix = 'draft';

export default {
    // 删除草稿
    [`${prefix}Delete`]: {
        url: '/web/draft/:bizType',
        type: AJAX_TYPE.DELETE
    },
    // 获取草稿
    [`${prefix}Query`]: {
        url: '/web/draft/:bizType',
        type: AJAX_TYPE.GET
    },
    // 保存草稿
    [`${prefix}Save`]: {
        url: '/web/draft/save',
        type: AJAX_TYPE.POST
    },
}